<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} la hora</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las horas</option>
        <option v-for="AgendaBloqueHora in AgendaBloqueHoras" :value="AgendaBloqueHora.AgendaBloqueId" :key="AgendaBloqueHora.AgendaBloqueId">{{AgendaBloqueHora.HoraBloque}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        AgendaBloqueHoras: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch("A_SICCIJ_Catalogo_Establecer001Area", parametros);
    },
    methods: {
      cargaCatalogoAgendaBloqueHoras() {
        console.log('cargando horas')
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SICCIJ.catalogos.C004AgendaBloquesHoras, this.parametros, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal))
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.AgendaBloqueHoras = respuesta.data.AgendaBloqueHoras;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                //this.AgendaBloqueFechas = respuesta.data.AgendaBloqueFechas.filter(cond => this.parametros.filtros.some(area => area == cond.AreaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer004AgendaBloquesHoras", parametros);
        this.$emit("valorParaElPadre", [evento,this.AgendaBloqueHoras[evento.target.selectedIndex -1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoAgendaBloqueHoras();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/C004AgendaBloquesHoras.vue